import axios from 'axios';
import {
  CREATE_HOTEL_REQUEST,
  CREATE_HOTEL_SUCCESS,
  CREATE_HOTEL_FAIL,
  GET_HOTELS_REQUEST,
  GET_HOTELS_SUCCESS,
  GET_HOTELS_FAIL,
  GET_HOTEL_REQUEST,
  GET_HOTEL_SUCCESS,
  GET_HOTEL_FAIL,
  UPDATE_HOTEL_REQUEST,
  UPDATE_HOTEL_SUCCESS,
  UPDATE_HOTEL_FAIL,
  HIDE_HOTEL_FOR_WEB_REQUEST,
  HIDE_HOTEL_FOR_WEB_SUCCESS,
  HIDE_HOTEL_FOR_WEB_FAIL,
  HIDE_HOTEL_FOR_PORTAL_REQUEST,
  HIDE_HOTEL_FOR_PORTAL_SUCCESS,
  HIDE_HOTEL_FOR_PORTAL_FAIL,
  CLEAR_ERROR,
  GET_HOTELS_PORTAL_REQUEST,
  GET_HOTELS_PORTAL_SUCCESS,
  GET_HOTELS_PORTAL_FAIL,
} from '../constants/hotelsConstant';

import { host } from '../../utils/config';

export const createHotel = (details) => async (dispatch) => {
  try {
    // console.log("create Hotel")

    dispatch({ type: CREATE_HOTEL_REQUEST });
    const config = { headers: { 'Content-Type': 'application/json' }, withCredentials: true };

    const data = await axios.post(`${host}/events/api/v1/hotel/new`, details, config);

    dispatch({ type: CREATE_HOTEL_SUCCESS, payload: data.data.user });
  } catch (error) {
    dispatch({
      type: CREATE_HOTEL_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const getHotels = () => async (dispatch) => {
  try {
    dispatch({ type: GET_HOTELS_REQUEST });
    const config = { headers: { 'Content-Type': 'application/json' }, withCredentials: true };

    const { data } = await axios.get(`${host}/events/api/v1/hotels`, config);

    dispatch({ type: GET_HOTELS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_HOTELS_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const getHotelsForPortal = () => async (dispatch) => {
  try {
    dispatch({ type: GET_HOTELS_PORTAL_REQUEST });
    const config = { headers: { 'Content-Type': 'application/json' }, withCredentials: true };

    const { data } = await axios.get(`${host}/events/api/v1/hotels-portal`, config);

    dispatch({ type: GET_HOTELS_PORTAL_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_HOTELS_PORTAL_FAIL,
      payload: error.response.data.message,
    });
  }
};

// export const getEventsForWebsite = () => async (dispatch) => {
//     try {
//         dispatch({ type: GET_HOTELS_WEBSITE_REQUEST });
//         const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };

//         const {data} = await axios.get(`${host}/events/api/v1/events-website`, config);

//         dispatch({ type: GET_HOTELS_WEBSITE_SUCCESS, payload: data });

//     } catch (error) {
//         dispatch({
//             type: GET_HOTELS_WEBSITE_FAIL,
//             payload: error.response.data.message,
//         });
//     }
// };

export const getHotel = (id) => async (dispatch) => {
  // console.log(id,userId,role)
  try {
    dispatch({ type: GET_HOTEL_REQUEST });
    const config = { headers: { 'Content-Type': 'application/json' }, withCredentials: true };

    const { data } = await axios.get(`${host}/events/api/v1/hotel/${id}`, config);

    dispatch({ type: GET_HOTEL_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_HOTEL_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const updateHotels = (memberDetails, id) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_HOTEL_REQUEST });
    const config = { headers: { 'Content-Type': 'application/json' }, withCredentials: true };

    const { data } = await axios.put(`${host}/events/api/v1/hotel/update/${id}`, memberDetails, config);

    dispatch({ type: UPDATE_HOTEL_SUCCESS, payload: data.success });
  } catch (error) {
    dispatch({
      type: UPDATE_HOTEL_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const hideWebHotels = (id, active) => async (dispatch) => {
  try {
    dispatch({ type: HIDE_HOTEL_FOR_WEB_REQUEST });
    const config = { headers: { 'Content-Type': 'application/json' }, withCredentials: true };

    const { data } = await axios.put(`${host}/events/api/v1/delete/member/${id}`, { active }, config);

    dispatch({ type: HIDE_HOTEL_FOR_WEB_SUCCESS, payload: data.success });
  } catch (error) {
    dispatch({
      type: HIDE_HOTEL_FOR_WEB_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const hidePortalHotels = (id, active) => async (dispatch) => {
  try {
    dispatch({ type: HIDE_HOTEL_FOR_PORTAL_REQUEST });
    const config = { headers: { 'Content-Type': 'application/json' }, withCredentials: true };

    const { data } = await axios.put(`${host}/events/api/v1/delete/member/${id}`, { active }, config);

    dispatch({ type: HIDE_HOTEL_FOR_PORTAL_SUCCESS, payload: data.success });
  } catch (error) {
    dispatch({
      type: HIDE_HOTEL_FOR_PORTAL_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const clearError = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERROR });
};
